<form [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-label>Cliente</mat-label>
    <input
      type="text"
      #clientsSearchCtrl
      formControlName="ClientsSearchCtrl"
      matInput
      placeholder="Busque al cliente por razón social o CUIT"
      (input)="onClientSearchChange()"
      [matAutocomplete]="autClientSearch"
    />
    <mat-autocomplete
      #autClientSearch="matAutocomplete"
      (optionSelected)="clientSearchSelected($event.option.value)"
      [displayWith]="displayFn"
    >
      <mat-option
        *ngFor="let clientSearch of clientsSearchFilter"
        [value]="clientSearch"
      >
        <div>
          <img
            class="profile-img"
            [src]="getProfileClientSearchPath(clientSearch)"
          />
          <b>{{ clientSearch.BusinessName }}</b
          >, [{{ clientSearch.Cuit }}]
        </div>
      </mat-option>
    </mat-autocomplete>
    <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
  </mat-form-field>
  <button
    matSuffix
    type="button"
    *ngIf="canEdit === true && !loading && !isSelected && !readOnly"
    (click)="edit()"
    mat-mini-fab
  >
    <mat-icon>add</mat-icon>
  </button>

</form>
